import tableAppDynamicProviders from './tableAppDynamicProviders';

export default {
  title: 'V.T. Dynamic Providers',
  attributeName: 'appProvider',
  getURL: 'appId/appDynamicProvider',
  removeURL: 'appId/appProvider',
  sessionParams: ['appId'],
  noArea: true,
  removeNameField:'name',
  removeText:'You are about to remove the V.T. Dynamic Provider with name ##name##.',
  tableConfig: tableAppDynamicProviders,
  autoUpdate: true,
};
